import { Id, toast } from "react-toastify";
import { Container } from "../components/common/HtmlTags/Container/Container";
import { Span } from "../components/common/HtmlTags/Span/Span";

const defaultToasterOptions = {
  closeButton: false,
  position: "top-center" as const,
};

export const ErrorToaster = (data: string, errorCode?: number) => {
  const ToastContent = () => {
    return (
      <Container>
        <Span>{data + " "}</Span>
      </Container>
    );
  };
  return toast.error(<ToastContent />, {
    toastId: errorCode || "",
    closeButton: true,
    className: "toast-error toast-custom-style",
    position: "top-center",
    autoClose: 3000,
    closeOnClick: false,
  });
};

export const SuccessToaster = (message: string, toastId?: Id) => {
  return toast.success(message, {
    toastId: toastId || undefined,
    ...defaultToasterOptions,
  });
};

export const WarningToaster = (message: string, toastId?: Id) => {
  return toast.warning(message, {
    toastId: toastId || undefined,
    ...defaultToasterOptions,

  });
};
export const InfoToaster = (message: string, toastId?: Id) => {
  return toast.info(message, {
    toastId: toastId || undefined,
    ...defaultToasterOptions,
  });
};
